import { sendMessage, detectExtensionId } from './utils';

// Preload current extension ID
detectExtensionId().catch((error) => {
  if (process.env.REACT_APP_ENV === 'development') {
    // eslint-disable-next-line no-console
    console.warn('Could not detect extension ID', error);
  }
});

export const isOnboardingFinished = () =>
  sendMessage('external.isOnboardingFinished');

export const restartOnboarding = () =>
  sendMessage('external.restartOnboarding');

export const skipOnboarding = () => sendMessage('external.skipOnboarding');

export const updateAuthCookie = (token) =>
  sendMessage('external.updateAuthToken', { token });

export const resetMixpanel = () => sendMessage('external.resetMixpanel');

export const clearAuthCookie = () => sendMessage('external.clearAuthToken');

export { EXTENSION_STORE_URL } from './const';
